import React, { Component } from "react";
import style from "./InventorySummery.module.css";
import { connect } from "react-redux";
import moment from "moment";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";
import { fetchInventorySummary } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";

export class InventorySummery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "1",
      isScreenLoaded: false
    };
  }

  componentDidMount() {
    document.title = 'Track Inventory - TechToMedix';
    this.props.fetchInventorySummary();
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
  }, 2000);
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  render() {
    const filteredInventoryData = this.props.inventorysummaryData.inventorysummaryData.find(
      (element, index) => {
        return element.category_id == this.state.activeTab;
      }
    );
    // console.log(
    //   "***************",
    //   this.props.inventorysummaryData.inventorysummaryData
    // );
    if(!this.state.isScreenLoaded){
      return(
      <div className="dashboard-loader">
            <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
        );
  }
    return (
      <div>
        {this.props.loading ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} className={style.loading} />
          </div>
        ) : (
          <div className={`inventory-audit ${style.inventoryAuditMainWrapper}`}>
            <div className="row">
              <div className="col-lg-12">
                <h3>Track Inventory</h3>
              </div>
              <div className="col-lg-12 intro-text">
                <p className="mb-4">
                  This is the dashboard for the inventory. It shows the total
                  number of products, quantity, threshold for each sub category.
                  The main categories are shown as tabs having data for each
                  subcategory into it.
                </p>
              </div>
            </div>
            <div className={`row ${style.inventoryAuditTabsWrapper}`}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.inventorysummaryData.inventorysummaryData.map(
                    (element, index) => (
                      <NavItem>
                        <NavLink
                          className={{
                            active: this.state.activeTab === `${index + 1}`,
                          }}
                          onClick={() => {
                            this.toggle(`${index + 1}`);
                          }}
                        >
                          {element.category_name}
                        </NavLink>
                      </NavItem>
                    )
                  )}
                </Nav>
                <TabContent
                  activeTab={this.state.activeTab}
                  className={style.tabContentWrapper}
                >
                  {this.props.inventorysummaryData.inventorysummaryData.map(
                    (element, index) => (
                      <TabPane
                        tabId={`${index + 1}`}
                        key={`${index + 1}`}
                        className={style.auditTrailTabContent}
                      >
                        <div class="inventory-tab-wrapper d-flex flex-wrap">
                          {filteredInventoryData &&
                            filteredInventoryData.sub_category &&
                            filteredInventoryData.sub_category.map(
                              (element, index) => (
                                <div class="inventory-product d-flex flex-column align-items-center">
                                  <div class="product-title d-flex align-items-center">
                                    <h6>{element.sub_category_name}</h6>
                                  </div>
                                  <div class="product-quantity">
                                    <span>
                                      {element.threshold_count
                                        ? element.threshold_count
                                        : "0"}
                                    </span>
                                  </div>
                                  <div class="product-stats">
                                    <p>
                                      Threshold:{" "}
                                      <span>
                                        {element.lower_threshold
                                          ? element.lower_threshold
                                          : "0"}
                                      </span>{" "}
                                      -{" "}
                                      <span>
                                        {element.upper_threshold
                                          ? element.upper_threshold
                                          : "0"}
                                      </span>{" "}
                                    </p>
                                    <p>
                                      No. of Products :{" "}
                                      <span>
                                        {" "}
                                        {element.product_count
                                          ? element.product_count
                                          : "0"}
                                      </span>
                                    </p>
                                    <p>
                                      Exp. Date :{" "}
                                      <span>
                                        {element.expiry_date
                                          ? moment(element.expiry_date).format(
                                              "YYYY/MM/DD"
                                            )
                                          : "null"}
                                      </span>{" "}
                                    </p>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                        {!filteredInventoryData.sub_category && (
                          <div>No data found</div>
                        )}
                      </TabPane>
                    )
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    inventorysummaryData: state.inventorysummaryData,
    loading: state.inventorysummaryData.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInventorySummary: () => dispatch(fetchInventorySummary()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventorySummery);
